/**
 * Axis type sizes shared by the SciChart surfaces that appear side by side.
 *
 * The Subsurface Explorer puts the 2D Profile next to the Cross-Section, and the Gun Barrel in
 * the same slot on other hosts. The Cross-Section had set these two sizes explicitly while the
 * pre-drill charts set nothing and took SciChart's own (larger) defaults, so two charts an inch
 * apart rendered their titles and ticks at visibly different sizes.
 *
 * The values are the Cross-Section's originals, so adopting this module changed nothing about
 * what it already drew — only the charts beside it moved.
 *
 * These are axis titles and tick labels only. In-plot annotations (formation names, stick
 * labels, the A–A′ guide letters) are deliberately smaller and stay with their own charts.
 */

/** Axis titles — "TVD (ft)", "Distance along section (ft)". */
export const AXIS_TITLE_FONT_SIZE = 12;

/** Tick labels along an axis. */
export const AXIS_LABEL_FONT_SIZE = 11;
